export class ApproveModel{
    "studyId":Number;
    "userId":Number;
    "patientId":Number;
    "testValue":Number;
"mobileNumber":Number;

}